import React from 'react';

const Cookies: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Política de Cookies</h1>
          <p className="text-green-100">Última atualização: Fevereiro de 2026</p>
        </div>
      </div>

      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="prose prose-green max-w-none">
            <h2>1. O que são Cookies?</h2>
            <p>
              Cookies são pequenos arquivos de texto armazenados no seu dispositivo quando você visita um site. Eles são amplamente utilizados para fazer os sites funcionarem de forma mais eficiente e fornecer informações aos proprietários do site.
            </p>

            <h2>2. Como Usamos Cookies</h2>
            <p>A BOILX utiliza cookies para:</p>
            <ul>
              <li>Manter você conectado à sua conta</li>
              <li>Lembrar suas preferências</li>
              <li>Entender como você usa nossa plataforma</li>
              <li>Melhorar nossos serviços</li>
              <li>Exibir anúncios relevantes</li>
            </ul>

            <h2>3. Tipos de Cookies que Utilizamos</h2>
            
            <h3>Cookies Essenciais</h3>
            <p>
              Necessários para o funcionamento básico do site. Sem eles, a plataforma não funciona corretamente.
            </p>
            <ul>
              <li>Autenticação de usuário</li>
              <li>Segurança</li>
              <li>Carrinho de compras</li>
            </ul>

            <h3>Cookies de Desempenho</h3>
            <p>
              Coletam informações sobre como você usa o site para melhorar a experiência.
            </p>
            <ul>
              <li>Google Analytics</li>
              <li>Métricas de erro</li>
              <li>Tempo de carregamento</li>
            </ul>

            <h3>Cookies de Funcionalidade</h3>
            <p>
              Lembram suas escolhas para proporcionar uma experiência personalizada.
            </p>
            <ul>
              <li>Preferências de idioma</li>
              <li>Região/localização</li>
              <li>Configurações de exibição</li>
            </ul>

            <h3>Cookies de Marketing</h3>
            <p>
              Usados para exibir anúncios relevantes e medir a eficácia das campanhas.
            </p>
            <ul>
              <li>Facebook Pixel</li>
              <li>Google Ads</li>
              <li>Remarketing</li>
            </ul>

            <h2>4. Cookies de Terceiros</h2>
            <p>Alguns cookies são colocados por serviços de terceiros que aparecem em nossas páginas:</p>
            <ul>
              <li>Google (Analytics, Ads)</li>
              <li>Facebook</li>
              <li>Stripe (pagamentos)</li>
              <li>Cloudinary (imagens)</li>
            </ul>

            <h2>5. Gerenciando Cookies</h2>
            <p>
              Você pode controlar e/ou excluir cookies através das configurações do seu navegador:
            </p>
            <ul>
              <li><strong>Chrome:</strong> Configurações &gt; Privacidade e segurança &gt; Cookies</li>
              <li><strong>Firefox:</strong> Opções &gt; Privacidade &gt; Histórico</li>
              <li><strong>Safari:</strong> Preferências &gt; Privacidade</li>
              <li><strong>Edge:</strong> Configurações &gt; Cookies e permissões do site</li>
            </ul>
            <p>
              <strong>Atenção:</strong> Desabilitar cookies pode afetar o funcionamento da plataforma.
            </p>

            <h2>6. Tempo de Armazenamento</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-left">Tipo</th>
                  <th className="border p-2 text-left">Duração</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border p-2">Sessão</td>
                  <td className="border p-2">Até fechar o navegador</td>
                </tr>
                <tr>
                  <td className="border p-2">Persistentes</td>
                  <td className="border p-2">Até 2 anos</td>
                </tr>
                <tr>
                  <td className="border p-2">Marketing</td>
                  <td className="border p-2">Até 90 dias</td>
                </tr>
              </tbody>
            </table>

            <h2>7. Alterações</h2>
            <p>
              Esta política pode ser atualizada periodicamente. A data da última atualização está indicada no topo desta página.
            </p>

            <h2>8. Contato</h2>
            <p>
              Para dúvidas sobre nossa política de cookies: <a href="mailto:privacidade@boilx.com.br">privacidade@boilx.com.br</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
